import { render, staticRenderFns } from "./H52WeApp.vue?vue&type=template&id=1b42a5ec&scoped=true&"
import script from "./H52WeApp.vue?vue&type=script&lang=ts&"
export * from "./H52WeApp.vue?vue&type=script&lang=ts&"
import style0 from "./H52WeApp.vue?vue&type=style&index=0&id=1b42a5ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42a5ec",
  null
  
)

export default component.exports